// Shopify Auto Cart Fill Script - Cart Total Between $250-$350
// Adds products to reach a cart total between $250 and $350

(async function() {
  // Check if the URL contains the action=black-friday parameter
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get('action');
  
  if (action !== 'black-friday') {
    return; // Exit if the action parameter is not present
  }

  console.log('Cart fill action detected. Starting process...');

  const MIN_CART_TOTAL = 250;
  const MAX_CART_TOTAL = 350;

  try {
    // Clear the cart first
    await clearCart();
    console.log('Cart cleared');
    
    // Get random products and fill cart to target total
    await fillCartToTargetTotal(MIN_CART_TOTAL, MAX_CART_TOTAL);
    
  } catch (error) {
    console.error('Error filling cart:', error);
    alert('An error occurred while filling the cart. Please check the console for details.');
  }
})();

// Function to clear the cart
async function clearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }
    
    return true;
  } catch (error) {
    console.error('Error clearing cart:', error);
    return false;
  }
}

// Function to fill cart to target total
async function fillCartToTargetTotal(minTotal, maxTotal) {
  let currentTotal = 0;
  let attempts = 0;
  const maxAttempts = 50;
  const addedProducts = [];
  
  // Calculate total pages (900 products / 250 per page = 4 pages)
  const totalPages = 4;
  
  while (currentTotal < minTotal && attempts < maxAttempts) {
    attempts++;
    
    try {
      // Get random page number
      const randomPage = Math.floor(Math.random() * totalPages) + 1;
      console.log(`Fetching products from page ${randomPage}`);
      
      // Fetch products from random page
      const products = await fetchProductsFromPage(randomPage);
      
      if (products.length === 0) {
        console.log(`No products found on page ${randomPage}`);
        continue;
      }
      
      // Shuffle products for randomness
      const shuffledProducts = shuffleArray(products);
      
      // Try to find a product that fits within our target range
      let productAdded = false;
      
      for (const product of shuffledProducts) {
        const price = parseFloat(product.price);
        
        // Check if adding this product would keep us under or within the max total
        if (currentTotal + price <= maxTotal) {
          // Always add quantity of 1
          const quantity = 1;
          
          // Add product to cart
          await addItemToCart(product.variant_id, quantity);
          
          currentTotal += price * quantity;
          addedProducts.push({
            title: product.title,
            price: price,
            quantity: quantity,
            subtotal: price * quantity
          });
          
          console.log(`Added: ${product.title} x${quantity} ($${price} each) - Cart total: $${currentTotal.toFixed(2)}`);
          
          productAdded = true;
          
          // Check if we've reached our target range
          if (currentTotal >= minTotal && currentTotal <= maxTotal) {
            console.log(`✓ Target reached! Cart total: $${currentTotal.toFixed(2)}`);
            showSuccessMessage(currentTotal, addedProducts);
            
            // Redirect to cart
            setTimeout(() => {
              window.location.href = '/cart';
            }, 2000);
            return;
          }
          
          break; // Move to next iteration after adding a product
        }
      }
      
      // If no product could be added from this page, try another page
      if (!productAdded) {
        console.log('No suitable products found on this page, trying another...');
      }
      
    } catch (error) {
      console.error('Error in fill loop:', error);
    }
  }
  
  // If we've exited the loop, check final total
  if (currentTotal >= minTotal && currentTotal <= maxTotal) {
    console.log(`✓ Target reached! Final cart total: $${currentTotal.toFixed(2)}`);
    showSuccessMessage(currentTotal, addedProducts);
  } else if (currentTotal > 0) {
    console.log(`⚠ Could not reach exact target. Cart total: $${currentTotal.toFixed(2)}`);
    alert(`Cart filled to $${currentTotal.toFixed(2)}. Could not find products to reach exactly $${minTotal}-$${maxTotal}.`);
  } else {
    alert('Could not add any products to cart.');
  }
  
  setTimeout(() => {
    window.location.href = '/cart';
  }, 2000);
}

// Function to fetch products from a specific page
async function fetchProductsFromPage(page) {
  const products = [];
  
  try {
    const response = await fetch(`/products.json?page=${page}&limit=250`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch products');
    }
    
    const data = await response.json();
    
    if (data.products && data.products.length > 0) {
      // Extract all available variants
      data.products.forEach(product => {
        product.variants.forEach(variant => {
          if (variant.available) {
            products.push({
              product_id: product.id,
              variant_id: variant.id,
              title: `${product.title}${variant.title !== 'Default Title' ? ' - ' + variant.title : ''}`,
              price: variant.price,
              handle: product.handle
            });
          }
        });
      });
    }
    
  } catch (error) {
    console.error(`Error fetching products from page ${page}:`, error);
  }
  
  return products;
}

// Function to add a single item to cart
async function addItemToCart(variantId, quantity) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity
        }]
      })
    });
    
    if (!response.ok) {
      throw new Error('Failed to add item to cart');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error adding item to cart:', error);
    throw error;
  }
}

// Function to shuffle array (Fisher-Yates algorithm)
function shuffleArray(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

// Function to show success message
function showSuccessMessage(total, products) {
  const message = document.createElement('div');
  message.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    z-index: 9999;
    font-family: Arial, sans-serif;
    max-width: 400px;
    animation: slideIn 0.3s ease-out;
  `;
  
  let productsList = products.slice(0, 5).map(p => 
    `• ${p.title} x${p.quantity} - $${p.subtotal.toFixed(2)}`
  ).join('<br>');
  
  if (products.length > 5) {
    productsList += `<br>• ... and ${products.length - 5} more items`;
  }
  
  message.innerHTML = `
    <div style="font-weight: bold; font-size: 18px; margin-bottom: 10px;">
      ✓ Cart filled successfully!
    </div>
    <div style="margin-bottom: 10px;">
      Total: $${total.toFixed(2)}
    </div>
    <div style="font-size: 14px; opacity: 0.9;">
      ${productsList}
    </div>
  `;
  
  // Add animation
  const style = document.createElement('style');
  style.textContent = `
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `;
  document.head.appendChild(style);
  
  document.body.appendChild(message);
  
  // Remove message after 5 seconds
  setTimeout(() => {
    message.style.opacity = '0';
    message.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => message.remove(), 300);
  }, 5000);
}